import type { PitcherEnv } from '@lib/sdk/interfaces'
import { applyDaisyUiTheme } from '@theme/daisyUi'
import { DEFAULT_LIGHT_PALETTE, GRAY_PRIMARY_VARIANTS } from '@theme/light.const'
import { exportObjectToGlobalCssProperties } from '@theme/theme.utils'

function applyPitcherTheme(primaryColor: string | null = DEFAULT_LIGHT_PALETTE.primary) {
  if (!primaryColor || primaryColor === DEFAULT_LIGHT_PALETTE.primary) {
    return exportObjectToGlobalCssProperties(DEFAULT_LIGHT_PALETTE)
  } else {
    return exportObjectToGlobalCssProperties({
      ...DEFAULT_LIGHT_PALETTE,
      ...GRAY_PRIMARY_VARIANTS,
      primary: primaryColor,
    })
  }
}

export function applyTheme(
  envFetcher: () => Promise<PitcherEnv> = () =>
    Promise.resolve({ pitcher: { instance: { color: null } } } as PitcherEnv),
): void {
  if (!globalThis.document) return

  envFetcher().then((env) => {
    const color =
      typeof window !== 'undefined' && window.parent?.jsApiLocation === 'admin'
        ? DEFAULT_LIGHT_PALETTE.primary
        : env?.pitcher?.instance?.color
    applyPitcherTheme(color)
    applyDaisyUiTheme(color)
  })
}

if (globalThis.document) {
  const typedGlobalThis = globalThis as typeof globalThis & { pitcher?: any }
  if (typedGlobalThis.pitcher) applyTheme(() => typedGlobalThis.pitcher?.useApi?.()?.getEnv?.())
  else applyTheme()
}
